module.exports = __webpack_public_path__ + "img/c.879bbb6d.png";